import { useQuery } from '@tanstack/react-query';
import { sourcesApi } from '../api/sources.api';
import type { SourcePaginationParams } from '../types/sources.types';
import { sourceKeys } from './queryKeys';

export const useSources = (pagination: SourcePaginationParams = {}) => {
  const { page = 1, pageSize = 10, searchTerm, sortBy = 'name', sortAscending = true } = pagination;

  const { data, isFetching, isError } = useQuery({
    queryKey: sourceKeys.list(page, pageSize, searchTerm, sortBy, sortAscending),
    queryFn: () =>
      sourcesApi.getSources({
        page,
        pageSize,
        searchTerm,
        sortBy,
        sortAscending,
      }),
    placeholderData: (prev) => prev,
  });

  return {
    sources: data?.data?.items ?? [],
    pagination: {
      page: data?.data?.page ?? 1,
      pageSize: data?.data?.pageSize ?? 10,
      totalCount: data?.data?.totalCount ?? 0,
      totalPages: data?.data?.totalPages ?? 0,
      hasPreviousPage: data?.data?.hasPreviousPage ?? false,
      hasNextPage: data?.data?.hasNextPage ?? false,
      firstItemOnPage: data?.data?.firstItemOnPage,
      lastItemOnPage: data?.data?.lastItemOnPage,
    },
    isFetching,
    isError,
  };
};
